import React from "react"
import _ from "lodash"
import CartItem from "../CartItem"

export default ({cart}) => (
  <div style={_.size(cart.ItemElements) > 0 ? {
    borderTop: "1px solid #ccc"
  } : {}}>
    {_.map(cart.ItemElements, item => <CartItem item={item} key={item.ProCataNo}/>)}
  </div>
)